import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialStrip } from './components/TestimonialStrip';
import { Problema } from './components/Problema';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Oferta } from './components/Oferta';
import { SistemaTotal } from './components/SistemaTotal';
import { Testimonios } from './components/Testimonios';
import { CostoDeNoTenerlo } from './components/CostoDeNoTenerlo';
import { Garantia } from './components/Garantia';
import { Faq } from './components/Faq';
import { CierreFinal } from './components/CierreFinal';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full overflow-x-hidden bg-white font-sans text-ink-900" data-id="element-0" data-mp="2wip734ny5m5z">
      <Hero data-id="element-1" data-mp="28t4k8aooa4rf" />
      <main data-id="element-2" data-mp="28sl3uyeo7ofi">
        <TestimonialStrip data-id="element-3" data-mp="28sbad0uf2z52" />
        <Problema data-id="element-4" data-mp="23vkuadim43jn" />
        <Tomos data-id="element-5" data-mp="23w4ek0vqj40u" />
        <Bonos data-id="element-6" data-mp="23ujlygszdv5m" />
        <Oferta data-id="element-7" data-mp="23v2rsz5cwt3a" />
        <SistemaTotal data-id="element-8" data-mp="23ti864kkyuk7" />
        <Testimonios data-id="element-9" data-mp="3ik7e6ay3c1o0" />
        <CostoDeNoTenerlo data-id="element-10" data-mp="3iiwdwl3utc1n" />
        <Garantia data-id="element-11" data-mp="3ijpbowku4r7n" />
        <Faq data-id="element-12" data-mp="3ii4su47vuwpm" />
        <CierreFinal data-id="element-13" data-mp="3mlj8uuvtnd32" />
      </main>
      <Footer data-id="element-14" data-mp="3mkhm3t5g125i" />
      <PurchasePopup data-id="element-15" data-mp="3mjzsz5e2v41t" />
    </div>;
}